import React from "react";
import Layout from "../../components/Layout/layout";
import AdvisoryCommitteeCard from "../../components/AdvisoryCommitteeCard/AdvisoryCommitteeCard";
import adv1 from "../../assets/advCommittee/adv1.png";
import adv2 from "../../assets/advCommittee/adv2.png";
import adv3 from "../../assets/advCommittee/adv3.jpg";
import adv4 from "../../assets/advCommittee/adv4.jpg";
import adv5 from "../../assets/advCommittee/adv5.jpg";
import speaker1 from "../../assets/images/ProfKyleRollins.jpeg";
import speaker2 from "../../assets/images/speaker2.jpg";
import speaker3 from "../../assets/images/speaker3.jpg";
import speaker4 from "../../assets/images/speaker4.png";
import speaker5 from "../../assets/images/speaker5.jpg";
import speaker6 from "../../assets/images/speaker6.jpeg";
import speaker7 from "../../assets/images/speaker7.jpeg";
import speaker8 from "../../assets/images/speaker8.jpeg";
import speaker9 from "../../assets/images/speaker9.jpeg";
import speaker10 from "../../assets/images/speaker10.jpeg";
import speaker11 from "../../assets/images/speaker11.jpeg";
import speaker12 from "../../assets/images/speaker12.png";
import speaker13 from "../../assets/images/prof_yasuda.jpg";
import speaker14 from "../../assets/images/ConfCoChair.jpg";

const AdvisoryCommittee = () => {
  const sortedMembers = [
    {
      img: adv1,
      name: "Professor Ishihara Kenji",
      por: "Chuo University, Japan",
      link: "https://research.com/u/kenji-ishihara",
    },
    {
      img: adv2,
      name: "Professor Emeritus Idriss Izzat (Ed)",
      por: "University of California, Davis",
      link: "https://engineering.ucdavis.edu/news/geotechnical-engineering-trailblazer-professor-emeritus-izzat-ed-idriss",
    },
    {
      img: adv3,
      name: "Prof. Madhav M.R. ",
      por: "Visiting Professor, IIT, Hyderabad Professor Emeritus, J.N.T.U, Hyderabad Resource Person, RGUKT Retired as Professor of Civil Engg., IIT Kanpur",
      link: "https://home.iitk.ac.in/~madhav/",
    },
    {
      img: adv4,
      name: "Dr. Bhandari R.K. ",
      por: "Former, Director of Central Building Research Institute of the Council of Scientific & Industrial Research, India and Former, United Nations Chief Technical Adviser to the Government of SriLanka",
      link: "https://www.nbro.gov.lk/index.php?option=com_content&view=article&id=396:heartiest-congratulations-to-dr-r-k-bhandari-on-the-occasion-of-receiving-the-esteemed-indian-national-award-netaji-subhas-chandra-bose-aapda-prabandhan-puraskar&catid=8&Itemid=190&lang=en",
    },
    {
      img: adv5,
      name: "Dr. Joseph Anil",
      por: "President, Indian Geotechnical Society",
      link: "https://igs.org.in/members/dr-anil-joseph1",
    },
    {
      name: "Prof. Asimaki Domniki",
      por: "California Institute of Technology, Pasadena, CA",
      img: speaker4,
      link: "https://asimaki.caltech.edu/index.html",
    },
    {
      name: "Prof. Choudhury D.",
      por: "IIT Bombay",
      img: speaker12,
      link: "https://www.civil.iitb.ac.in/faculty/details/prof-deepankar-choudhury",
    },
    {
      name: "Dr. Desai Chandrakant S.",
      por: "The University of Arizona, Tucson",
      img: speaker3,
      link: "https://www.u.arizona.edu/~csdesai/",
    },
    {
      name: "Prof. Elgamal Ahmed-Waeil",
      por: "University of California San Diego",
      img: speaker2,
      link: "https://www.researchgate.net/profile/Ahmed-Waeil-Elgamal",
    },
    {
      name: "Prof. Hazarika Hemanta",
      por: "Kyushu University",
      img: speaker10,
      link: "https://kyushu-u.elsevierpure.com/en/persons/hemanta-hazarika",
    },
    {
      name: "Prof. Kaynia Amir M.",
      por: "NTNU",
      img: speaker5,
      link: "https://www.ntnu.edu/employees/amir.kaynia",
    },
    {
      name: "Prof. Kokusho Takaji",
      por: "Chuo University, Tokyo, Japan",
      img: speaker7,
      link: "https://www.researchgate.net/profile/Takaji-Kokusho",
    },
    {
      name: "Prof. Foti Sebastiano",
      por: "Politecnico di Torino",
      img: speaker14,
      link: "https://www.researchgate.net/profile/Sebastiano-Foti",
    },
    {
      name: "Prof. Madabhushi Gopal S P",
      por: "University of Cambridge",
      img: speaker6,
      link: "https://www.researchgate.net/profile/Gopal-Madabhushi",
    },
    {
      name: "Prof. Saitoh Masato",
      por: "Saitama University",
      img: speaker9,
      link: "https://www.researchgate.net/profile/Masato-Saitoh",
    },
    {
      name: "Prof. Rollins Kyle",
      por: "Brigham Young University",
      img: speaker1,
      link: "https://www.researchgate.net/profile/Kyle-Rollins",
    },
    {
      name: "Prof. Sitharam T.G.",
      por: "Indian Institute of Science Bangalore",
      img: speaker11,
      link: "https://scholar.google.com.sg/citations?user=OKug7KsAAAAJ&hl=en",
    },
    {
      name: "Prof. Towhata Ikuo",
      por: "University of Tokyo, Japan",
      img: speaker8,
      link: "https://scholar.google.com/citations?user=AEJtbtIAAAAJ",
    },
    {
      name: "Prof. Yasuda Susumu",
      por: "Prof. Emeritus of Tokyo Denki University",
      img: speaker13,
      link: "http://seags.ait.asia/news-announcements/prof-susumu-yasuda/",
    },
  ];

  return (
    <Layout>
      <div className="bg-[#D7DDE1] py-10 ">
        <div className="w-full md:w-3/4 px-10 md:px-20 py-8 bg-white z-20 mb-[5vh] relative mx-auto">
          <div className="font-bold text-4xl text-[#1F7E95] pb-4">
            ADVISORY COMMITTEE
          </div>
          <div className="flex flex-wrap justify-between">
            {sortedMembers.map((speaker, index) => (
              <a key={index} href={speaker.link}>
                <AdvisoryCommitteeCard
                  img={speaker.img}
                  name={speaker.name}
                  por={speaker.por}
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AdvisoryCommittee;
